import { render, staticRenderFns } from "./AccessibilityWidget.vue?vue&type=template&id=1a2f13ba&scoped=true"
import script from "./AccessibilityWidget.vue?vue&type=script&lang=js"
export * from "./AccessibilityWidget.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityWidget.vue?vue&type=style&index=0&id=1a2f13ba&prod&lang=css"
import style1 from "./AccessibilityWidget.vue?vue&type=style&index=1&id=1a2f13ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f13ba",
  null
  
)

export default component.exports